let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("27oU7")).then(() => parcelRequire('guTYc'));